import { renderNodesMethods } from "./vectorElements/renderNodesMethods";
import { renderConnectionsMethods } from "./vectorElements/renderConnectionsMethods";
import { renderPrimitivesMethods } from "./vectorElements/renderPrimitivesMethods";

export const drawStaticElements = ({ canvas, layout, isPrint }) => {
  if (!canvas || !layout) {
    return;
  }

  canvas.innerHTML = "";

  renderPrimitivesMethods.ensureDefs(canvas);

  const {
    lines = [],
    rects = [],
    texts = [],
    nodes = [],
    twoAngleLines = [],
    bottomLeftAngleLines = [],
    leftBracketPolyLines = [],
  } = layout;

  lines.forEach((ln) => {
    renderPrimitivesMethods.drawLine(
      canvas,
      ln.from.x,
      ln.from.y,
      ln.to.x,
      ln.to.y,
      { stroke: ln.stroke, isWireless: ln.isWireless },
    );
  });

  rects.forEach((r) => {
    renderPrimitivesMethods.drawRect(canvas, r.x, r.y, r.styles);
  });

  twoAngleLines.forEach((ln) => {
    renderConnectionsMethods.drawTwoAngleLine(canvas, ln);
  });

  twoAngleLines.forEach((ln) => {
    renderConnectionsMethods.drawTwoAngleLine(canvas, ln);
  });

  twoAngleLines.forEach((ln) => {
    renderConnectionsMethods.drawTwoAngleLine(canvas, ln);
  });
  bottomLeftAngleLines.forEach((ln) => {
    renderConnectionsMethods.drawBottomLeftAngleLine(canvas, ln);
  });
  leftBracketPolyLines.forEach((ln) => {
    renderConnectionsMethods.drawLeftBracketPolyLine(
      canvas,
      ln.from,
      ln.to,
      ln.leftGap,
      ln.isWireless,
    );
  });

  renderPrimitivesMethods.ensureDefs(canvas);
  nodes.forEach((node) => {
    renderNodesMethods.drawNode(canvas, node.x, node.y, { ...node, isPrint });
  });

  texts.forEach((t) => {
    renderPrimitivesMethods.drawText(canvas, t.x, t.y, t.text, { ...t.styles });
  });
};
